// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"d925ea32","453":"1818fb52","455":"d693d44d"}[chunkId] + ".chunk.js";
};